import { takeLatest, call, put } from 'redux-saga/effects';

import axiosInstance from '../../services/AuthHeader';
import { setPasswordResetEmailError } from '../reducers/authorization';
import { setSending, unsetSending } from '../reducers/serverCommunication';

export const SAGA_SEND_PASSWORD_RESET = 'SAGA_SEND_PASSWORD_RESET';

export function sendPasswordResetSaga(payload) {
  return { type: SAGA_SEND_PASSWORD_RESET, payload };
}

const handleResetPassword = async (email) =>
  axiosInstance.post('/api/auth/resetPassword', { email, username: email }).then((res) => res.data);

export function* sendPasswordReset(action) {
  yield put(setSending);
  try {
    yield call(handleResetPassword, action.payload);
    yield put(setPasswordResetEmailError(false));
  } catch (e) {
    yield put(setPasswordResetEmailError(true));
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForSendPasswordReset() {
  yield takeLatest(SAGA_SEND_PASSWORD_RESET, sendPasswordReset);
}
